interface DeletePopupDescriptionProps {
  name?: string
  resource?: string
  action?: string
  subText?: string
}
export const DeletePopupDescription: React.FC<DeletePopupDescriptionProps> = ({
  name = '',
  resource = '',
  action = 'delete',
  subText,
}) => (
  <>
    <div>
      Are you sure you want to {action}
      {resource ? ` the ${resource}` : ' '} <span className="text-p-600">{`"${name}"`}</span>?
    </div>
    {subText && <div className="text-s-400 mt-4 text-tertiary">{subText}</div>}
  </>
)
